import React from "react";
import LandmarkLogo from "../LandmarkLogo";
import { Headshot } from "./shared";

// Full-bleed headshot with a dark gradient and type set over the photo.
export default function PhotoOverlay({ data, headshot }) {
  const name = data.name || "New Hire";
  return (
    <div className="wp-canvas wp-t-overlay">
      <Headshot headshot={headshot} className="wp-t-overlay__photo" />
      <div className="wp-t-overlay__shade" />

      <header className="wp-t-overlay__top">
        <LandmarkLogo width={230} />
        {data.team && <div className="wp-t-overlay__team">{data.team}</div>}
      </header>

      {data.note && <div className="wp-t-overlay__note">{data.note}</div>}

      <div className="wp-t-overlay__copy">
        <p className="wp-t-overlay__eyebrow">{data.tagline || "Welcome to Landmark"}</p>
        <h1>{name}</h1>
        {data.role && <p className="wp-t-overlay__role">{data.role}</p>}
        <div className="wp-t-overlay__foot">
          <span className="wp-t-overlay__rule" />
          <span>landmarkventures.com</span>
        </div>
      </div>
    </div>
  );
}
